/**
 * A global namespace for aria-valuenow.
 */
const ariaValueNow = "aria-valuenow";
export default ariaValueNow;
